import { render } from "./DefinitionEdit.vue?vue&type=template&id=09e0b736"
import script from "./DefinitionEdit.vue?vue&type=script&lang=js"
export * from "./DefinitionEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__